/*中文*/
const zh_CN = {
	langsOptions: {
		en_US: '英语',
		hi_IN: '印地语',
		zh_CN: '中文'
	},
  ThirdParty: {
    title: '第三方登录',
    ways: {
      Google: '谷歌',
      Facebook: '脸书',
      Twitter: '推特'
    }
  },
	pageTab: {
		Home: '首页',
		Discounts: '优惠',
		Deposit: '存款',
		Service: '客服',
		My: '我的',
    tab1Txt: 'Cricket',
    tab2Txt: 'Sports',
    tab3Txt: 'Games',
    tab4Txt: 'Team',
    tab5Txt: 'Profile'
	},
	header: {
		login: '登录',
		register: '注册',
		service: '客服中心',
	},
	newsTitle: ['充值信息', '维护信息', '异常通知', '优惠通知', '获奖通知', '首页公告', '首页推荐'],
	register: {
		username: '账号',
		// usernamePlace: '6~12位字母、数字或字母数字组合',
		usernamePlace: '6~12位字母数字组合',
    usernamePlace1: '请输入账号',
    passwordPlace1: '请输入密码',
		userError: '请输入6~12位字母、数字或字母数字组合账号',
		password: '密码',
		passwordPlace: '6~12位字母、数字或字母数字组合',
		passwordError: '请输入6~12位字母、数字或字母数字组合的密码',
		repeatPassword: '确认密码',
		repeatPasswordPlace: '请再次确认密码',
		phone: '手机号',
		phonePlace: '请输入手机号',
		phoneTips: '手机号码是验证信息的重要途经，请正确填写。',
		agentCode: '代理代码',
		agentCodePlace: '没有可不填',
		vrifyCode: '验证码',
		vrifyCodePlace: '请输入正确验证码',
		rule: '我同意',
		userRegistrationAgreement: '「用户注册协议」',
		loginbtn: '立即登录',
		existingAccount: '已有账号？',
		confirmTitle: '注册成功，完成实名认证，即可领取现金奖励！',
		authenticateNow: '前去认证',
		certifyLater: '稍后认证',
		successTips: '恭喜您！注册成功！',
    successTips2: 'Welcome to GAMESTECH!',
		bankPart1: '您还可以',
		bankPart2: '绑定银行卡',
		bankPart3: '，以方便您随时取款！',
		startGame: '开始游戏',
		startDeposit: '立即存款',
		remember: '记住我',
		require: '必填',
		noRequire: '非必填',
		realName: '真实姓名',
		realNamePlace: '请输入真实姓名',
    realNamePlace1: '请输入数字或字母，中间只能有一个空格',
		qq: 'QQ',
		qqPlace: '请输入QQ',
		qqError: '请输入首位不能为0的QQ号',
		wechat: '微信',
		wechatPlace: '请输入微信',
    wechatError: '5个以上字母、数字、下划线或减号，以字母开头',
		email: '邮箱',
		emailPlace: '请输入正确邮箱',
		withdrawPassword: '提款密码',
		withdrawPasswordPlace: '请输入提款密码',
    loginTips1: "New Customer? ",
    loginTips2: "Open New Account",
    loginTips3: "In order to place bet(s) you must be a registered user",
    loginTips4: "By proceeding you confirm you are 18 years of age or older.",
    loginTips5: "Let’s activate your account! ",
    loginTips6: "You have successfully created your account! To unlock your welcomeoffer and start playing, check your email and click the activation link.",
    registerBtn: '现在注册',
    registerBtn1: '现在注册',
    signUp: '创建账号',
    signUp1: '立即创建账户',
    login: '立即登录'
	},
	ValidTips: {
		name: '您已完成实名认证，',
		phone: '您已完成手机认证，',
		email: '您已完成邮箱认证，',
		conactService: '如需修改请联系客服！',
		noPhone: '您的手机未认证，请点击确定去认证',
		noDrawPwd: '您的提款密码未设置，请点击确定去设置',
		noPhoneDrawPwd: '您的手机未认证，提款密码未设置，请点击确定去完善',
		noPhoneDrawPwd2: "请在绑定银行帐户之前填写手机号码和提款密码",
	},
	download: {
		title: '',
		app: 'APP',
		appDownload: 'APP下载',
		subTitle: '安全 | 稳定 | 快捷',
		downloadNow: '下载'
	},
	nav: {
		HotGame: '热门',
		Sport: '体育',
		Live: '真人',
    CatchFish: '捕鱼',
		Slot: '电子',
    Lottery: '彩票',
    CardGame: '棋牌'
	},
	agency: {
		title: '代理合作',
		affiliateAgree: '联营协议',
		agencyLogin: '代理登录',
		agencyRegister: '代理注册'
	},
	others: {
		save: 'Save',
		click: "Click",
		success: "success",
		total: "Total",
		all: 'All',
		selectLang: 'Select Langes',
		CustomerService: '联系客服',
		roger: '知道了',
		monetaryUnit: '¥',
		loadingTxt: '加载中',
		refreshTxt: '刷新中',
		loadmore: '点击加载更多',
		noData1: '暂无更多数据',
		noData2: '暂无数据',
		noData3: '暂无更多记录',
		confirm: '确 定',
		cancel: '取 消',
		Delete: '删除',
		next: '下一步',
		tips: '提示',
		refreshSuccess: '刷新成功',
		copy: '复制',
		copySuceess: '复制成功',
		select: '请选择',
    select1: '请选择',
		finish: '完成',
		close: '关闭',
		search: '搜索',
		searchGame: '搜索游戏',
    reset: '重置',
    startTime: '开始时间',
    endTime: '结束时间',
    timeError: '请选择开始时间和结束时间，且开始时间必须小于结束时间',
	},
	Forms: {
    agreeTips: '请勾选注册条款！',
    requiredFields: '此项必填',
		gameAccount: '游戏账号',
		nameCheck: '请输入6~12位字母、数字或字母数字组合账号',
		phone: '手机号',
		phoneCheck: '请输入正确手机号',
		email: '邮箱账号',
		emailCheck: '输入邮箱格式有误',
		sendCodeBefore: '发送',
		sendCodeAfter: '秒',
		verifCode: '验证码',
		verifCodePlace: '请输入验证码',
		oldPwd: '原密码',
		newPwd: '新密码',
		newPwdPlace: '请输入新密码',
		pwdDiff: '新密码不可和旧密码一样！',
		repeatPwd: '确认新密码',
		repeatPwdPlace: '请再次输入新密码',
		newDiff: '两次新密码不一样',
		pwdError: '请输入6~12位字母、数字或字母数字组合的密码',
		drawPwdError: '请输入4位及以上字母、数字或字母数字组合的提款密码',
		sendSuccess: '发送成功'
	},
	upload: {
		imgSize: 'M',
		imgSizeTxt: '图片大小',
		imgType: '图片类型',
		select: '+ 请选择文件上传',
		successTips: '文件上传成功',
		errorTips: '文件大小不能超过'
	},
	service: {
		live_chat: 'Live Chat',
		whatsapp: 'Whatsapp',
		telegram: 'Telegram',
		commonProblem: '常见问题'
	},
	discounts: {
    join: '详情',
		queryresult: '查询结果',
    userUpgrade: '升级查询',
    betOrderNo: '请输入注单编号',
		needLoin: '登录后才可领取',
		noDiscounts: '暂无优惠!',
		moreDiscount: '查看更多优惠',
    getBonus: '领取红利',
		discountsReceived: '领取优惠',
		checkPlatform: '请选择平台',
		checkMoney: '请输入金额',
		checkBisnum: '请输入投注单号',
		userInformation: {
			userAccount: '会员账号',
			levelInfo: '当前等级',
			totalBetflow: '累积投注额',
			totalUpAmount: '累积晋级彩金',
			totalWeekAmount: '累积周俸禄彩金',
			totalMonthAmount: '累积月俸禄彩金',
			nextLevelBetflow: '晋级投注额'
		},
    tips1: 'Current and Upcoming Campaigns!',
    unlogined: {
      txt1: "FANTASTIC PROMOTIONS",
      txt2: "Win amazing prizes",
      txt3: "Here you will find our latest and greatest promotions.",
      txt4: "Tailored to your taste and super easy to find.",
      txt5: "Bookmark this page and never miss an opportunity again.",

      txt6: "Check back here to find",
      txt7: "Amazing promotions",
      txt8: "Brand New Rewards",
      txt9: "Brilliant Bonuses to Claim",
      txt10: "Join now and find out more!",
      txt11: "MOST POPULAR GAMES"
    }
	},
	// 存款
	Deposit: {
    orderTip: '您的存款请求已发送',
    referralAmount: '推荐充值金额',
		saveLimit: '存款限额',
		receiptAccount: '收款账号',
		receiptAccountPlace: '请输入正确的收款账号',
		saveMoneyNum: '存入金额',
		saveMoneyNumPlace: '请输入正确的存入金额',
		orderName: '存款人姓名',
		orderName2: '存款人姓名',
		orderNamePlace: '请输入正确的存款人姓名',
		saveCertificate: '存款凭证',
		saveCertificatePlace: '请上传存款凭证',
		payTutorial: '支付教程',
		orderNumber: '订单号',
		receiptMoney: '金额',
		receipt: '收款',
		account: '账号',
		timer: '提交时间',
		finish: '完成',
		base: {
			title: '存款',
			savaType: '请选择存款方式',
			nonsupport: '该支付方式暂不支持！'
		},
		bankTransfer: {
			title: '银行汇款',
      		bankAddr: 'IFSC CODE',
			bank: '银行',
			beneficiary: '收款人',
			account: '账户',
			contactUs: '请联系客服',
			sendTips: '您的存款要求已发出',
			orderMoney: '金额',
			orderDueBank: '收款银行',
			oderBankName: '户名',
			transfer: '跨行转账',
			transferTips1: '存入的金额将在30分钟内反映在您的余额中。',
			transferTips2: '银行不承诺汇款到达时间。如果您的资金没有出现在24小时内，请联系在线支持!',
			typeofpayment: '付款方式',
			Transferamount: '转账金额',
			TransferUSDTAmount: '您要转账USDT金额',
            RupeeAmount: '将批准卢比金额'
		},
		Recharge: {
			title: '充值',
			payType: '支付方式',
			payChannel: '选择支付通道',
			channel: '通道',
			bank: '选择银行',
			bankPlace: '请选择支付银行',
			selectMoney: '选择金额',
			saveMoney: '存款金额',
			saveMoneyPlace: '输入存款金额',
			fixedMoney: '请选择固定金额',
			insufficient: '银行卡余额不足',
			payOthersType: '请更换其他支付方式进行付款',
			back: '返回继续充值',
			paySuccess: '充值成功',
			finish: '支付完成'
		},
		Neteller: {
			title: 'Neteller',
			cost: 'FEE',
			tips: 'Your deposit request is sent'
		},
		Paytm: {
			title: 'Paytm',
		},
		Skrill: {
			title: 'Skrill'
		}
	},
	forget: {
		title: '忘记密码',
		RetrieveSMS: '短信找回',
		MailboxRetrieve: '邮箱找回',
		CustomerRetrieve: '客服找回',
		checking: '验证',
		userPlace: '请输入您的游戏账号',
		phonePlace: '请输入绑定的手机号',
		emailPlace: '请输入绑定的邮箱号',
		resetPwd: '重置密码',
		tips: '没有自动跳转？点击联系客服>',
		tips1: '我们已经向您的手机号发送一条包含验证码的短信。若没有收到，请点击发送验证码。',
		tips2: '我们已经向您的邮箱发送一份包含验证码的邮件。若没有收到，请点击发送验证码。',
		tips3: '提示：系统发送的邮件可能被邮件运营商误判为垃圾邮件，您可以在收件箱和垃圾邮件箱中查找。',
		submit: '提 交',
		successTips1: '密码找回',
		successTips2: '您的密码设置成功'
	},
	signIn: { // 签到
    signTipsReward1: '签到送奖品',
    signTipsReward2: '签到福利',
    surprise: '有惊喜',
    success: '签到成功',
    successTips: '可积累提现哟~',
		daySign: '每日签到',
		otherIncentives: '其他奖励',
		cashBonus: '现金奖励',
		currentIntegral: '当前积分',
		sign: '签到',
		signed: '已签到',
		signTips1: '你有一笔会赚钱的积分待领取',
		signTips2: '你已经连续签到',
		signTips3: ' 天，今天也别忘记哦！^_^',
		signTips4: '明日签到',
		signTips5: '明日签到神秘奖励等你哦~',
		Integral: '积分',
		signInTalent: '签到达人',
		awardTips1: '恭喜您！',
		awardTips2: '如果是实物，需联系客服领取',
		integralChange: '积分兑换',
		integral: '所需积分',
		confirmChange: '确认兑换',
		signNow: '立即签到',
		gameOptions: [
			'糖果大陆', '标准五卷轴', '月光宝盒', '寻访海豚', '美女枪手丛林激战', ' 功夫龙',
			'黄金工厂', ' 顶级王牌名人游戏', ' 维京狂热', '上流社会', '埃及女神伊西絲', ' 招财进宝',
			'富裕人生', '迷失拉斯维加斯', '数字大转轮', '金瓶梅2', '斗牛', ' 金钱豹',
			'超级 888', ' 寿司多多', '航海时代', '喜福猴年', '泰山', ' 冒险之旅',
			'古墓丽影', '寻宝记', '双喜熊猫', '公鸡王', '泰山', ' 亚洲幻想',
			'少林宝藏', '三国拉霸', '梦幻邂逅', '表情金币', '禁忌王座', ' 花花公子',
		],
		choosePrize: '请选择兑换奖品',
		lackOfIntegral: '积分不足',
		continuously: '连续签到获得',
		jetton: '筹码',
		size: '元',
		signInTab: {
			integral: '积分记录',
			cash: '兑换现金',
			forRecord: '兑换记录',
			rule: '签到规则'
		},
		myself: '我的',
		recordTips1: '你有一笔会赚钱的积分待领取',
		signDay: '已连续签到',
		day: '天',
		dayModifier: '第',
		noDataTips: '每一笔积分，都是财富的积累'
	},
	mine: {
		welcome: '欢迎您',
		visitor: '游客',
		accountManageText: '账号管理',
		bindNow: '立即绑定',
		bindSuccess: '绑定成功',
		filtrate: '筛选',
		timers: '时间',
		timeOptions: {
			'90': '全部',
			'1': '24小时',
			'7': '7日',
			'30': '1个月'
		},
		minBaseOptions1: {
			SaveMonery: '存款',
			Withdrawal: '取款',
			Wallet: '钱包',
			StationLetter: '站内信'
		},
		Withdrawal: {
      mainBalance: '主账户余额',
			addBank: '添加银行卡',
			balance: '余额',
			detailsTitle: '账户明细',
			cash: '可提现金',
			recharge: '充值',
			drawMoney: '提款',
			platform: '平台',
			takeBack: '一键取回',
      takeBack1: '取回',
			addbankcard: {
				pageTitle: '银行卡管理',
				tips1: '修改手机号请联系客服',
				tips2: '未设置交易密码，是否前去设置？',
				tips3: '保障账户安全，是否前去设置？',
				personName: '持卡人',
				personNamePlace: '请输入持卡人真实姓名',
				bankName: '银行名称',
				bankNamePlace: '请选择银行名称',
				cardNumber: '银行卡号',
				cardNumberPlace: '必须10 ~ 50 位数字',
				cardNumberError: '请输入10 ~ 50位银行卡号!',
				bankBranch: '银行分行号',
				bankBranchPlace: '请输入正确银行分行号',
        bankBranchPlace2: '请输入正确的8 ~ 20银行分行号',
				bankBindPhone: '银行预留手机号',
				bankBindPhonePlace: '必须是在银行注册的联系电话',
				withdrawPassword: '交易密码',
				withdrawPasswordPlace: '请输入交易密码'
			},
			Draw: {
				pageTitle: '取款',
				money: '提款金额',
				moneyPlace: '输入提款金额',
				pwd: '提款密码',
				pwdPlace: '输入提款密码',
				canDraw: '可取资金',
				drawTips1: '提现金额大于',
				drawTips2: '才可提款',
				drawTips3: '提款前请设置提款密码以及认证手机号',
				drawTips4: ', 请勿输入小数',
				deleteTips1: '删除银行卡',
				deleteTips2: '删除银行卡需要联系客服,确定删除？',
				phoneTitle: '您还未认证手机号',
				phoneConfirm: '前去认证',
				phoneCancel: '稍后认证',
				pwdTitle: '您还未设置提款密码',
				pwdConfirm: '前去设置',
				pwdCancel: '稍后设置',
				pwdInputTitle: '请输入提款密码',
				deleteSucess: '删除成功，1秒后回到钱包',
				takeBackSuccess: '取回成功',
				applySuccess: '申请提款成功，1秒后回到钱包',
				check: {
					amount1: '请输入大于0的整数数值',
					amount2: '可提余额不足',
					pwd: '提款密码不能为空'
				}
			}
		},
		wallet: {
			title: '钱包',
			balance: '钱包余额'
		},
		stationLetter: {
			title: '站内信',
			pageTab: {
				myMessage: '我的消息',
				sendMessage: '发送新消息'
			},
			myMessageTab: {
				unread: '最新消息',
				read: '已读消息'
			},
			noMsg: '暂无消息',
			noMoreMsg: '暂无更多信息',
			deleteSelect: '请选择删除信息',
			deleteSuccess: '删除成功',
			msgType: '消息类型',
			msgTypeOptions: {
				money: '存取款问题',
				discounts: '优惠活动',
				games: '游戏问题',
				other: '其它问题',
				proposal: '建议',
				complaint: '投诉'
			},
			theme: '主题',
			themePlace: '请输入主题',
			desc: '内容',
			descPlace: '请输入内容',
			send: '发送',
			selectMsgType: '请选择问题类型',
			sendSuccess: '发送成功'
		},
		minBaseOptions2: {
			discount: '优惠',
			latestDeposit: '存款订单记录',
			task: '任务',
			betRecord: '投注记录',
			merchRecord: '交易记录',
			lockAmount: '资金锁定明细',
			gameCollect: '我的收藏',
			InviteFriends: '邀请好友',
			agentCenter: '代理中心',
			appDownload: 'APP下载',
			affiliate: "代理介绍"
		},
		betRecord: {
			title: '投注记录',
			total: '总共',
			size: '笔',
			betMoney: '下注金额',
			effectiveBet: '有效投注',
			profit: '盈利金额',
			gameType: '游戏类型',
			platNumber: '平台编号',
			betOrder: '注单编号',
			betTime: '下注时间',
			settltTime: '结算时间',
			customTime: '自定义时间',
			selectTime: '请选择时间段',
			startTime: '开始时间',
			endTime: '结束时间',
			timeError: '请选择开始时间和结束时间，且开始时间必须小于结束时间',
			gameType: '游戏分类',
			noData: '无账单信息',
			gamelist: {
				'-1': '所有',
				'1': '老虎机',
				'2': '真人',
				'3': '体育',
				'4': '彩票',
				'5': '捕鱼',
				'6': '棋牌',
				'8': '其他'
			}
		},
    LatestDeposit: {
    	title:'LatestDeposit',
      yes: "YES",
      no: "NO",
      continuePay: "Continue Payment",
    	cancel:'Revoke',
      dateTimes:'Trans. Date',
      Type:'Deposit Type',
      Amount:'Amount',
      ID:' Deposit ID',
      Status:'Status',
      Action:'Action',
      confirmTips:'Cancel your deposit',
      tipsTips1:'Your application has been revoked!',
      tipsTips2:'Reminder : Multiple Request Will Deemed To Account Suspended',
      Close:'Close',
    	goDeposit:'Go to Deposit List',
    	paytips1:'You still have unapproved deposits, ',
    	paytips2:'please wait for approval or revoke your deposit ticket',
    	gamelist: {
    		'0': 'Processing',
    		'1': 'Succeeded',
    		'2': 'Failed',
    		'3': 'Canceled',
    	}
    
    },
		tradingRecord: {
			title: '交易记录',
			tradingType: '交易分类',
			tradingTypeOptions: {
				0: '全部',
				1: '系统调帐',
				2: '充值存款',
				3: '秒速提款',
				4: '转入游戏',
				5: '游戏转出',
				8: '优惠红利',
				9: '人工存入',
				10: '人工取出',

        11: '彩票购买',
        12: '彩票派彩',
        13: '彩票撤单',
        14: '彩票日常任务',
        16: '上级代理手动转入',
        17: '购买余额宝',
        18: '赎回余额宝',
        19: '彩票购买',
        20: '彩票派奖',
        21: '彩票回退',

        22: '体育购买',
        23: '体育派奖',
        24: '体育本金回退',
        30: '邀请推广返佣',

        40: '投注',
        41: '派彩',

        90: '打赏',
        91: '竞猜下注',
        92: '竞猜派彩',
        93: '竞猜取消',

				100: '申请中',
			}
		},
		tradingRecordDetails: {
			title: '交易详情',
			orderNumber: '账单编号'
		},
		lockAmount: {
			title: '资金锁定明细',
			rechargeTab: '充值锁定',
			discountsTab: '优惠锁定',
			platform: '全平台',
			platformPlace: '请选择平台',
			lockStatus: '锁定状态',
			lockStatusPlace: '请选择锁定状态',
			bonus: '请选择红利状态',
			bonusType: '红利类型',
			loackAmonutOptions: {
				all: '全部状态',
				lock: '锁定中',
				unlock: '已解锁',
				cancel: '已取消'
			},
			loackAmonutStatus: {
				deposit: {
					0: '申请中',
					1: '成功',
					2: '失败',
					3: '冻结',
					4: '取消 '
				},
				bonus: {
					0: '申请中',
					1: '进行中',
					2: '成功发放',
					3: '拒绝',
					4: '失败',
					5: '未领取',
					6: '未抽中'
				}
			},
			bonusTypeOption: {
				all: '全部类型',
				waterRebate: '流水返利',
				softLoan: '存款优惠',
				rescueGold: '救援金',
				upgradeAwards: 'VIP升级奖励',
				winAwards: 'VIP蝉联奖励',
				otherPreferential: '其他优惠',
				joinPreferential: '注册优惠'
			},
			platformOption: {
				all: '全部平台',
				main: '主账户'
			},
			loackItem: {
				capital: '充值本金',
				size: '元',
				lockMoney: '锁定金额',
				waterComplete: '流水完成',
				waterTarget: '目标流水',
				unlock: '取消锁定',
				bonus: '红利名称',
				moneyNum: '金额',
				remainingWater: '剩余流水要求',
				platform: '平台',
				unlocked: '解锁成功'
			}
		},
		invite: {
			title: '邀请好友',
			scan: '扫码下载APP',
			link1: '推广链接',
			link2: '下载APP',
			link3: '推荐码',
			tips: '好友可通过任意一种方式完成注册',
			activity: '活动内容',
			account: '账户',
			receive: '是否领取',
      received: '已领取',
      cashingPrize: '领取奖金',
      outDate: '已过期',
			noActivity: '暂无活动',
			anyWay: '好友可通过任意一种方式完成注册'
		},
		accountManage: {
			title: '账号管理',
			nickName: '会员昵称',
			name: '真实姓名',
			phone: '手机号码',
			email: '邮箱',
			loginPwd: '登录密码',
			drawPws: '提款密码',
			loiginOut: '退出登录',
			authe: '去认证',
			edit: '修改',
			setting: '设置'
		},
		verifiedAuth: {
			title: '实名认证',
			tips: '注意：通过实名认证后，姓名将不可修改。提款人提款户名均为您的真实姓名',
			name: '姓名',
			namePlace: '请输入您的真实姓名',
			IDNO: '身份证号',
			IDNOPlace: '请输入您的身份证号',
			successTips1: '实名认证成功,代理邀请红利发放成功！详情请查看我的优惠。',
			successTips2: '实名认证成功',
			nameValid: '你已经完成过实名认证，请勿重复实名，如果疑问请咨询客服！'
		},
		mobileAuth: {
			title: '手机号认证',
			phoneError: '发送短信的手机号与提交认证的手机号不匹配',
			phonePlace: '请输入您的手机号码',
			verifCodePlace: '请输入短信验证码',
			successTips: '手机号认证成功',
			authenticated: '手机号已认证 请勿重复认证'
		},
		emailAuth: {
			title: '邮箱认证',
			tips1: '我们将向您的邮箱发送一份包含验证链接的邮件，您收到邮件后，点击链接即可。',
			tips2: '提示：系统发送的邮件可能被邮件运营商误判为垃圾邮件，您可以在收件箱和垃圾邮件箱中查找。',
			email: '邮箱地址',
			emailError: '邮箱格式不正确',
			emailPlace: '请输入您的邮箱地址',
			verifCodePlace: '请输入邮箱验证码',
			codeSuccess: '已发送验证码，请注意查收',
			successTips: '邮箱认证成功',
			authenticated: '邮箱已认证 请勿重复认证'
		},
		editPwd: {
			title: '修改登录密码',
			tips: '请注意，密码变更完成後，您将需要立即以新密码重新登入',
			oldPwdPlace: '请输入原登录密码',
			successTips: '您的登录密码已修改成功',
			loginOut: '请重新登录'
		},
		withdrawPwd: {
			title: '修改提款密码',
			pwdPlace: '请输入原提款密码',
			newPwdPlace: '请输入新提款密码',
			tips: '忘记提款密码，请联系客服！',
			successTips: '提款密码设置成功！'
		}
	},
	wheel: { // 抽奖转盘
    title:'玩幸运大转盘',
    smalltitle: '豪礼赚翻天',
		lotteryNum: '剩余抽奖',
		lotterySize: '次',
		winRecord: '我的中奖记录',
		noRecord: '您暂无中奖纪录',
		dispatched: '已派送',
		winPrize1: '运气真好，中得',
		winPrize2: '大奖！',
		sendPrize: '奖金已发放，详见交易记录',
		prizeTips: '点击联系客服领取',
		noPrizeNum: '您剩余抽奖次数: ',
		prizeIng: '抽奖正在进行，请不要重复点击！',
    congratulation: '恭喜您',
    prizeInfo: '中奖信息',
    thanksJoin: '谢谢参与',
    lotterNeed: '抽奖需知',
    rules: '活动规则',
    start: '开始',
    gameName: '幸运大转盘',
    history: '历史中奖记录',
    needLogin: '登录才可以抽奖哟！'
	},
  betting: {
    title: 'GT 彩票',
    lottery: '彩票',
    stopBet: '封盘中禁止投注',
    betMinAmount: '最小投注金额',
    needLogin: '您还未登录哟！',
    AvailableBalance: '可用余额',
    betSuccess: '投注成功！',
    recharge: '充值',
    inLottery: '开奖中',
    rule: '查看规则',
    issues: '期号',
    rules: '投注规则',
    betSubmit: '投注',
    addcart: '加入购物车',
    clear: '清除',
    add: '+',
    totalTxt: '总计',
    noselected: '请选择投注号码！',
    noEnoughMoney: '你已选择投注金额大于可用余额！',
	limitMix: "Betting amount cannot be less than minimum required amount",
    settleType: {
      all: '全部',
      noSettle: '未结算',
      settle: '结算',
      win: '赢',
      lose: '输'
    },
    trafficList: {
      0: 'Number',
      10: 'Red',
      11: 'Yellow',
      12: 'Blue',
    },
    cartHead: {
      type: '类型',
      details: '投注详情',
      multiple: '倍数',
      money: '金额'
    },
    lotteryTab: {},
    countDown: '距下一期',
    record: {
      title1: '开奖记录',
      title2: '我的投注记录',
      title: '投注记录',
      orderNo: '订单号',
      betMoney: '投注金额',
      dealMoney: '交易金额',
      serviceAmount: '手续费',
      drawNum: '开奖号码',
      betNum: '投注号码',
      status: '状态',
      rewards: '回报',
      betTime: '投注时间',
      tableHead: {
        Period: '期号',
        Price: '奖池',
        Numbers: '开奖号码',
        Result: '中奖区域'
      },
    },
    betChart: {
      title: '彩票走势图',
      periodsNum: '期',
      lotteryNum: '彩票号码',
      statics: {
        showCount: '出现次数',
        averageMiss: '平均遗漏',
        miss: '当前遗漏',
        maxShwo: '最大连出',
        maxMiss: '最大遗漏'
      },
    },
    mybetTxt: "My Bets",
    seeAll: "See All",
    amountTxt: "Bet Slip",
    editAmout: "Edit quick amount",
    fast: "Fast",
    bets: "bets",
    totolNum: "Total Bet Slip",
    totolAmount: "Total Bet Amount",
    comfirmBet: "Confirm Bets",
  },
  games: {
    title: '游戏',
    play: '立即玩',
    acount: '游戏账户',
    amount: "金额",
    stayTuned: '敬请关注',
    collectSuccess: '收藏成功！',
    collectCancel: '已取消收藏！',
    hotGameType: {
      HotGame: 'TOP HITS',
      Live: 'LIVE CASINO',
      Sport: 'SPORTS',
      Slot: 'SLOTS',
      CatchFish: 'CATCH FISH'
    },
    liveType: {
      '0': 'All',
      '1':'Roulette',
      '2':'SIC BO',
      '3': 'Baccarat',
      '4':'Dragon Tiger',
      '5':'Black Jack',
      '6':'Other'
    }
  },

  Tasks: {
    reward: "领取奖励",
    invite: "邀请",
    play: '玩游戏',
    receiveSuccess: "任务领取成功！",
    receiveTips: "Reminder: If daily task reward do not claim ,it will be reset",
    finish: "Complete",
    tab: {
      depositTask: "Deposit Task",
      inviteTask: "Invitation Task",
      gameTask: "Game Task",
    }
  },
  home: {
    matchTab: {
      best: "Best",
      league: "League",
      collect: "Collection"
    },
    payTitle: "Deposit Method",
    links: {
      agent: "Agent Joining",
      guide: "Guide",
      faq: "Faq",
      rule: "Rules",
      about: "About Us"
    },
    company: "Copyright © 2003-{year} 11ic (International) Ltd"
  },
  team: {
    title: "promote to get bonus",
    size: "INR",
    size2: "万",
    videos: "Video Tutorial",
    videoTips: "Your browser does not support the video playback. ",
    table: {
      times: "Time",
      superior: "上级",
      amount: "Amount",
      status: "Status",
      rebateAmount: "Rebate amount",
      performanceQuota: "业绩额度",
      txt1: "每一万返佣",

      rank: "Rank",
      account: "Account",
      id: "ID",
      title: "Sports Section ",
      searchPla: "Input player name"
    },
    tabNav: {
      promotion: "My Promotions",
      performance: "Performance Inquiry",
      directly: "Players Inquiry",
      group: "Team Inquiry",
      invite: "Invite Friends"
    },
    Inquiry: {
      directly: {
        searchTxt: "Enter direct player’s Name",
        allNum: "Total number of player",
        newAdd: "Today new registrant",
        txt1: "Direct Affiliate Performance"
      },
      group: {
        searchTxt: "Enter Player Name of Team",
        allNum: "Total Number of TEAMS",
        newAdd: "New Additions of TEAM",
        txt1: "Number of players",
        txt2: "Performance of Team Today"
      }
    },
    CommissionRecordTitle: "Commission withdrawal record",
    promotion: {
      withdrawalTips1: "请输入大于0的提取金额",
      withdrawalTips2: "您已成功提取佣金",
      info: {
        ID: "My Name",
        superiorID: "Superior Name",
        temNums: "Number of Team members (new additions)",
        toDayPerformance: "Performance of Team Today",
        players: "Number of players(new additions)",
        todayDirectPerformance: "Direct Affiliate Performance Today",
        yesterdayCommission: "Commission yesterday",
        TodayCommission: "Commission Today",
        tips: "equals commission of direct affiliates+ Commission of Team"
      },
      commission: {
        nums: "Commission ready to be claimed",
        total: "Total Commission",
        withdrawal: "Commission Withdrawal",
        record: "Withdrawal record",
        ratio: "Commission ratio",
        tutorial: "Promotion tutorial"
      },
      inviteTips: "invite friends, you can earn cash bonus every day!",
      inviteLink: "Invitation Link",
      inviteCode: "Invitation code",
      withdrawalAmount: "Amount to withdraw: ",
      tutorial: {
        list1: [
          {
            txt: "怎么推广赚钱?",
            desc: "扫码或者点击邀请链接，选择在浏览器中打开，注册下载游戏，用您的专属二维码活动邀请链接推广即可。"
          },
          {
            txt: "推广邀请码在哪?",
            desc: "Team界面点击邀请好友，有您自己的专属二维码和注册链接~通过此方式注册的会员即可成为您的直属玩家，其邀请的下级会员皆为您的团队成员。以此类推，可无限裂变式发展。"
          },
          {
            txt: "业绩及佣金在哪里查看?",
            desc: "Team界面，能看到您的团队人数、团队业绩、直属人数、直属业绩、历史总佣金及可领取佣金等。"
          },
          {
            txt: "业绩是怎么算的?",
            desc: "业绩是指玩家在游戏内的有效投注。比如您推广了一个玩家，他这把下注赢500元，下把输300元，则他为您带来的业绩为800元。"
          },
          {
            txt: "充值提现有什么要求?",
            desc: "个人中心进行充值，充值的金额，一倍有效投注即可出款。"
          },
          {
            txt: "怎么提现?",
            desc: "个人中心点击提现，选择您要提现的银行卡即可。提现绑定的银行卡和姓名等信息必须准确无误，否则无法提现到账。"
          },
          {
            txt: "佣金多久结算?",
            desc: "无限代理模式返佣制度为日结算，每日23:59分清零，当日业绩达到多少按照佣金表进行返佣哦~"
          }
        ],
        proxyTips: "无限代理佣金示例表",
        list2: [
          {
            txt: "返佣计算方式",
            descList: [
              "直属返佣=总业绩返佣比 * 直属业绩",
              "团队返佣=(总业绩返佣比-直属总业绩返佣比) * 团队业绩",
              "A获得佣金=(B1直属返佣+B1团队返佣)+B2直属返佣+B3直属返佣",
              "B1获得佣金=C2直属返佣+C3直属返佣"
            ]
          },
          {
            txt: "总佣金",
            descList: ["总佣金=直属佣金+团队佣金"]
          },
          {
            txt: "结算时间",
            descList: ["每日结算一次，根据当日业绩，结算当天的佣金"]
          }
        ]
      }
    },
    performance: {
      tabData: {
        today: "Today",
        yesterday: "Yesterday"
      },
      totalBetAmount: "All performance",
      selfBetAmount: "Direct Affiliate Performance",
      teamBetAmount: "Team Performance",
      tips: "Affiliate,team,all profit made are yours",
      detailsTitle: "Sports Section "
    },
    RebateRatio: { // 返佣比例
      title: "Rebate ratio",
      tableTxt1: "Team performance/Daily",
    }
  },
  match: {
    InsufficientBalance : "主账户余额不足，请先充值！",
    more: "more",
    nodata: "No more matches",
    multiples: "All Multiples",
    clear: "Clear Betslip",
    betTotalMoney: "Place Bet",
    back: "Returns",
    winner: "胜者",
    locked: "locked",
    autoOdds: "自动接收最新赔率",
    autoOddsTips: "选中后，将增加出票成功率，且赔率以出票赔率为准（出票赔率可能和提交赔率一致）",
    done: "Done",
    limitMax: "超过最大投注金额",
    betResult: "Submit Successfully!",
    betRecord: "Search Betting History",
    continueBet: "Continue Betting",
    betAmount: "Number of Bets",
    noBetTips: "Please confirm bet amount",
    draw: "Draw",
    success: "Succeeded",
    failure: "Failure",

    records: {
      tips: "Reminder:  The current page only displays the betting records of GT Cricket, BTI, IBC, EXCHANGE betting records, please check in Other Games",
      nodata: "No data yet,continue playing",
      toBet: "To guess",
      otherGame: "Other games",
      items: {
        eventName: "Event Name",
        gametName: "Game Name",
        content: "Betting content",
        betAmount: "Bet amount",
        odds: "Odds",
        revenue: "Revenue",
        status: "Status",
        orderNo: "Order No."
      },
      status: {
        '99': "Unsettlement",
        '100': "Settled",
        '1': "Win",
        '0': "Lose",
        '-1': 'Refund'
      },
    }
  },
  ghistory: {
	title: 'Bet Detail',
	Playerid: 'Player ID',
	gameid: 'Game ID',
	insurance: 'insurance',
	WinorLoss: 'Total win/loss',
	betTime: 'Bet time:',
	orderNo: 'Txn. ID',
	Status: 'Status',
	Provider: 'Provider',
	Event: 'Event',
	betArea: 'Bet area',
	gameName: 'Game name',
	total: "Total",
	Odds: 'Odds',
	TotalBets: 'Total Bets',
	ValidBets: 'Valid Bets',
	WinorLoss2: 'Win/Loss',
	close: 'close',
	Running: 'Running',
	Settled: 'Settled',
  }
}
export default zh_CN



// WEBPACK FOOTER //
// ./src/pages/build902/i18n/langs/zh_CN.js